/* TrendyDukan theme.js — vanilla JS, no dependencies */
document.addEventListener('DOMContentLoaded', function () {

  /* ---- Mobile menu ---- */
  var menuBtn = document.querySelector('[data-mobile-menu-open]');
  var menuCloseBtn = document.querySelector('[data-mobile-menu-close]');
  var mobileMenu = document.querySelector('.td-mobile-menu');

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (menuBtn) menuBtn.addEventListener('click', openMenu);
  if (menuCloseBtn) menuCloseBtn.addEventListener('click', closeMenu);

  /* Cart drawer handled by TDCart (see bottom of file) */


  /* ---- Sticky header shrink on scroll ---- */
  var header = document.querySelector('.td-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 40) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    }, { passive: true });
  }

  /* ---- Fade-in on scroll ---- */
  var fadeEls = document.querySelectorAll('.td-fade-in');
  if ('IntersectionObserver' in window && fadeEls.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    fadeEls.forEach(function (el) { observer.observe(el); });
  } else {
    fadeEls.forEach(function (el) { el.classList.add('is-visible'); });
  }
});

/* ---- v2: gallery thumbs, sticky ATC, pincode checker ---- */
document.addEventListener('DOMContentLoaded', function () {

  /* Product gallery thumbnails */
  var mainImg = document.getElementById('td-main-image');
  document.querySelectorAll('.td-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImg && thumb.dataset.full) mainImg.src = thumb.dataset.full;
    });
  });



  /* Pincode checker — format validation only (no fake delivery promises) */
  var pinBtn = document.querySelector('[data-pincode-check]');
  if (pinBtn) {
    pinBtn.addEventListener('click', function () {
      var input = document.getElementById('td-pincode-input');
      var result = document.querySelector('[data-pincode-result]');
      if (!input || !result) return;
      var pin = input.value.trim();
      if (/^[1-9][0-9]{5}$/.test(pin)) {
        result.textContent = 'We ship to ' + pin + '. Processed in 1\u20133 business days, then 3\u20137 business days for delivery.';
        result.style.color = '#111';
      } else {
        result.textContent = 'Please enter a valid 6-digit Indian pincode.';
        result.style.color = '#777';
      }
    });
  }
});

/* ---- v8: product gallery (swipe on mobile, click on desktop) ---- */
document.addEventListener('DOMContentLoaded', function () {
  var gallery = document.querySelector('[data-gallery]');
  if (!gallery) return;

  var stage  = gallery.querySelector('[data-gallery-stage]');
  var slides = Array.prototype.slice.call(gallery.querySelectorAll('.td-gallery__slide'));
  var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.td-thumb'));
  var dots   = Array.prototype.slice.call(gallery.querySelectorAll('.td-dot'));
  if (slides.length < 2) return;

  var index = 0;
  var isMobile = function () { return window.matchMedia('(max-width: 989px)').matches; };

  function setActive(i) {
    index = Math.max(0, Math.min(i, slides.length - 1));
    slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
    thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === index); });
    dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
    if (isMobile() && stage) {
      stage.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { setActive(parseInt(t.dataset.thumb, 10)); });
  });

  // keep dots/thumbs in sync while the user swipes
  var scrollTimer;
  if (stage) {
    stage.addEventListener('scroll', function () {
      if (!isMobile()) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var nearest = 0, best = Infinity;
        slides.forEach(function (s, n) {
          var d = Math.abs(s.offsetLeft - stage.scrollLeft);
          if (d < best) { best = d; nearest = n; }
        });
        if (nearest !== index) {
          index = nearest;
          thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === index); });
          dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
        }
      }, 90);
    }, { passive: true });
  }

  // keyboard support on desktop
  gallery.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') setActive(index + 1);
    if (e.key === 'ArrowLeft')  setActive(index - 1);
  });
});

/* =========================================================
   TDCart — single, authoritative cart implementation
   Replaces the three separate add-to-cart paths that existed
   before (form submit, sticky button, Buy Now).

   Rules this follows:
   - Always uses Shopify's real cart endpoints (/cart/add.js, /cart.js)
   - Always sends cookies (credentials: 'same-origin')
   - Checks response.ok BEFORE treating an add as successful
   - Re-reads /cart.js after every add, so the drawer shows real state
   - Never stores cart data in localStorage
========================================================= */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var URLS = {
    add:   ROOT.replace(/\/$/, '') + '/cart/add.js',
    get:   ROOT.replace(/\/$/, '') + '/cart.js',
    page:  ROOT.replace(/\/$/, '') + '/cart',
    checkout: ROOT.replace(/\/$/, '') + '/checkout'
  };

  var drawer   = document.getElementById('td-cart-drawer');
  var drawerBody = document.getElementById('td-cart-drawer-body');
  var overlay  = drawer ? drawer.querySelector('.td-cart-drawer__overlay') : null;
  var closeBtn = drawer ? drawer.querySelector('.td-cart-drawer__close') : null;
  var busy = false;

  function money(cents) {
    return '₹' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function setCount(n) {
    document.querySelectorAll('.td-cart-count').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  function status(form, message, isError) {
    if (!form) return;
    var el = form.querySelector('[data-cart-status]');
    if (!el) return;
    el.textContent = message || '';
    el.className = 'td-form-status' + (isError ? ' is-error' : '') + (message ? ' is-visible' : '');
  }

  /* ---- Read the real cart and paint the drawer ---- */
  function refresh() {
    return fetch(URLS.get, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js returned ' + res.status);
        return res.json();
      })
      .then(function (cart) {
        setCount(cart.item_count);
        if (!drawerBody) return cart;

        if (cart.item_count === 0) {
          drawerBody.innerHTML =
            '<p class="td-drawer-empty">Your cart is empty.</p>' +
            '<a href="' + ROOT + 'collections/all" class="td-btn td-btn--outline td-btn--full">CONTINUE SHOPPING</a>';
          return cart;
        }

        var html = '<ul class="td-drawer-items">';
        cart.items.forEach(function (item) {
          var img = item.image
            ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" width="60" height="60" loading="lazy">'
            : '<span class="td-drawer-thumb"></span>';
          html +=
            '<li class="td-drawer-item">' + img +
              '<div class="td-drawer-item__info">' +
                '<p class="td-drawer-item__title">' + item.product_title + '</p>' +
                (item.variant_title && item.variant_title !== 'Default'
                  ? '<p class="td-drawer-item__variant">' + item.variant_title + '</p>' : '') +
                '<p class="td-drawer-item__meta">Qty ' + item.quantity + ' · ' + money(item.final_line_price) + '</p>' +
              '</div>' +
              '<button type="button" class="td-drawer-item__remove" data-remove-key="' + item.key + '" aria-label="Remove ' + item.product_title + '">&times;</button>' +
            '</li>';
        });
        html += '</ul>' +
          '<div class="td-drawer-foot">' +
            '<div class="td-drawer-subtotal"><span>Subtotal</span><strong>' + money(cart.total_price) + '</strong></div>' +
            '<p class="td-drawer-note">Shipping and discounts are calculated at checkout.</p>' +
            '<a href="' + URLS.checkout + '" class="td-btn td-btn--accent td-btn--full">CHECKOUT</a>' +
            '<a href="' + URLS.page + '" class="td-btn td-btn--outline td-btn--full">VIEW CART</a>' +
          '</div>';
        drawerBody.innerHTML = html;
        return cart;
      })
      .catch(function (err) {
        console.error('[TDCart] Could not read cart:', err);
        if (drawerBody) drawerBody.innerHTML = '<p class="td-drawer-empty">Couldn\'t load your cart. <a href="' + URLS.page + '">Open the cart page</a>.</p>';
      });
  }

  function open() {
    if (!drawer) { window.location.href = URLS.page; return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ---- The one add-to-cart path ---- */
  function addToCart(form, opts) {
    opts = opts || {};
    if (busy) return Promise.resolve();

    var idField = form.querySelector('[name="id"]');
    var variantId = idField ? idField.value : '';
    if (!variantId) {
      status(form, 'Please choose an option before adding to cart.', true);
      return Promise.resolve();
    }

    var qtyField = form.querySelector('[name="quantity"]');
    var quantity = qtyField ? parseInt(qtyField.value, 10) : 1;
    if (!quantity || quantity < 1) quantity = 1;

    busy = true;
    var buttons = form.querySelectorAll('button[type="submit"], [data-buy-now]');
    buttons.forEach(function (b) { b.disabled = true; b.classList.add('is-loading'); });
    status(form, '');

    var vid = String(variantId).replace(/[^0-9]/g, '');
    if (!vid) {
      status(form, 'This product is not available to add right now. Please refresh and try again.', true);
      busy = false;
      return Promise.resolve();
    }

    var body = 'id=' + encodeURIComponent(vid) + '&quantity=' + encodeURIComponent(quantity);

    return fetch(URLS.add, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: body
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            var msg = (data && (data.description || data.message)) || 'Sorry, this item could not be added. Please try again.';
            throw new Error(msg);
          }
          return data;
        });
      })
      .then(function () {
        // Only now is the item genuinely in Shopify's cart — re-read it
        return refresh();
      })
      .then(function () {
        if (opts.thenCheckout) {
          window.location.href = URLS.checkout;
          return;
        }
        open();
      })
      .catch(function (err) {
        console.error('[TDCart] Add to cart failed:', err);
        status(form, err.message, true);
      })
      .then(function () {
        busy = false;
        buttons.forEach(function (b) { b.disabled = false; b.classList.remove('is-loading'); });
      });
  }

  function removeLine(key) {
    return fetch(ROOT.replace(/\/$/, '') + '/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('remove failed');
        return refresh();
      })
      .catch(function (err) { console.error('[TDCart] Remove failed:', err); });
  }

  /* ---- Wiring (delegated, so it also covers markup added later) ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  document.addEventListener('click', function (e) {
    var buyNow = e.target.closest('[data-buy-now]');
    if (buyNow) {
      e.preventDefault();
      var f = buyNow.closest('[data-product-form]');
      if (f) addToCart(f, { thenCheckout: true });
      return;
    }

    var sticky = e.target.closest('[data-sticky-atc]');
    if (sticky) {
      e.preventDefault();
      var pf = document.querySelector('[data-product-form]');
      if (pf) addToCart(pf);
      return;
    }

    var rm = e.target.closest('[data-remove-key]');
    if (rm) {
      e.preventDefault();
      removeLine(rm.getAttribute('data-remove-key'));
      return;
    }

    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      open();
      refresh();
      return;
    }

    if (e.target.closest('.td-cart-drawer__close') || e.target.closest('.td-cart-drawer__overlay')) {
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close();
  });

  // Sync the badge with the real cart on every page load, including
  // back/forward navigation restored from the bfcache.
  document.addEventListener('DOMContentLoaded', refresh);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.TDCart = { add: addToCart, refresh: refresh, open: open, close: close };
})();
